import React, { useState } from "react";
import { Download } from "lucide-react";

const ExportButton = ({ 
  onExport, 
  formats = ["pdf", "excel", "csv"], 
  loading = false,
  label = "Export",
  className = ""
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format) => {
    setExporting(true);
    try {
      await onExport(format);
      setShowMenu(false);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setExporting(false);
    }
  };

  const formatIcons = {
    pdf: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M4 18h12V6h-4V2H4v16zm-2 1V0h10l4 4v15H2z" />
      </svg>
    ),
    excel: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M14 0H2v20h16V4l-4-4zm2 18H4V2h8v4h4v12z" />
      </svg>
    ),
    csv: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M4 2h12v2H4V2zm0 4h12v2H4V6zm0 4h12v2H4v-2zm0 4h12v2H4v-2z" />
      </svg>
    ),
  };

  return (
    <div className={`relative font-poppins ${className}`}>
      <button
        onClick={() => setShowMenu(!showMenu)}
        disabled={loading || exporting}
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Download size={18} />
        {label}
      </button>

      {showMenu && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg z-20 border border-gray-200 dark:border-gray-700">
            <div className="py-1">
              <div className="px-3 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase">
                Select Format
              </div>
              {formats.map((format) => (
                <button
                  key={format}
                  onClick={() => handleExport(format)}
                  disabled={exporting}
                  className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
                >
                  {formatIcons[format.toLowerCase()]}
                  <span className="capitalize">{format.toUpperCase()}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExportButton;

